// extracted by mini-css-extract-plugin
export default {"additionalDetails":"AdditionalViewingDetails_additionalDetails__CfDkV","dotContainer":"AdditionalViewingDetails_dotContainer__uwIYl"};